import { tryFetch } from '@/modules/services/http'
import type {
  MBoxDetailsRequest,
  MboxDetailsSectionResponse,
  OrderLineDetailsRequest,
} from '../models/types'
import { HttpMethod } from '@/modules/services/http/types/http.enums'

export const useSideMenuApi = () => {
  const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

  const fetchSideMenuInformationGeneral = async (
    body: MBoxDetailsRequest,
  ): Promise<{ data?: MboxDetailsSectionResponse; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'information-general'], {
      view: true,
      body,
    })

  const fetchSideMenuInformationShipment = async (
    body: MBoxDetailsRequest,
  ): Promise<{ data?: MboxDetailsSectionResponse; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'information-shipment'], {
      view: true,
      body,
    })

  const fetchSideMenuInformationRecipient = async (
    body: MBoxDetailsRequest,
  ): Promise<{ data?: MboxDetailsSectionResponse; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'information-recipient'], {
      view: true,
      body,
    })

  const fetchSideMenuProducts = async (
    body: MBoxDetailsRequest,
  ): Promise<{ data?: any; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'order-lines'], { view: true, body })

  const fetchSideMenuShipments = async (
    body: MBoxDetailsRequest,
  ): Promise<{ data?: MboxDetailsSectionResponse; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'shipments'], { view: true, body })

  const fetchTrackingUrl = async (
    objectId: string,
  ): Promise<{ data?: any; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Get, BASE_URL, ['side-menu', 'trackingurl'], {
      view: true,
      queryParams: {
        objectId: objectId,
      },
    })

  const fetchSideOrderLineDetails = async (
    body: OrderLineDetailsRequest,
  ): Promise<{ data?: any; error?: any; status: number }> =>
    await tryFetch(HttpMethod.Post, BASE_URL, ['side-menu', 'order-line-details'], {
      view: true,
      body,
    })

  return {
    fetchSideMenuInformationGeneral,
    fetchSideMenuInformationShipment,
    fetchSideMenuInformationRecipient,
    fetchSideMenuProducts,
    fetchSideMenuShipments,
    fetchTrackingUrl,
    fetchSideOrderLineDetails,
  }
}
